export const a4_portrait = {
  width: 1240,
  height: 1754,
};
export const a3_portrait = {
  width: 1754,
  height: 2481,
};
